import { Xyz } from "../../../models/2d3d/xyz";

declare const THREE: any;

/**
 *@description
 * Get wall size
 * @param {any} wall
 * @returns {Xyz} size
 * @function
 */
export const getWallSize = (wall): Xyz => {
  if (!wall.geometry.boundingBox) {
    wall.geometry.computeBoundingBox();
  }
  return wall.geometry.boundingBox.getSize(new THREE.Vector3());
};


// WEBPACK FOOTER //
// ./src/app/services/wall/utils/get-wall-size.ts